const pcxData = {
  slug: "pcx-160",
  name: "Honda PCX 160",

  hero: {
    shortDescription: "Premium scooter with advanced technology and comfort",

    variants: [
      {
        key: "cbs",
        label: "CBS",
        fullName: "Honda PCX 160 Exceptional Red CBS",
        startPrice: 34592000,
      },
      {
        key: "abs",
        label: "ABS",
        fullName: "Honda PCX 160 Phenomenal White ABS",
        startPrice: 39778000,
      },
      {
        key: "roadsync",
        label: "RoadSync",
        fullName: "Honda PCX 160 RoadSync Matte Black",
        startPrice: 42775000,
      },
    ],

    slides: [
      {
        variantKey: "cbs",
        image: "/assets/motor/produk/pcx/Honda-PCX-160-Exceptional-Red-CBS.webp",
        specs: {
          engine: "156.9 cc, 4 Langkah, SOHC, eSP+, Pendingin Cairan",
          power: "11,8 kW (15.8 HP) / 8.500 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "abs",
        image: "/assets/motor/produk/pcx/Honda-PCX-160-Phenomenal-White-ABS.webp",
        specs: {
          engine: "156.9 cc, 4 Langkah, SOHC, eSP+, Pendingin Cairan",
          power: "11,8 kW (15.8 HP) / 8.500 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "roadsync",
        image: "/assets/motor/produk/pcx/Honda-PCX-160-RoadSync-Matte-Black.webp",
        specs: {
          engine: "156.9 cc, 4 Langkah, SOHC, eSP+, Pendingin Cairan",
          power: "11,8 kW (15.8 HP) / 8.500 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text: "All New Honda PCX 160 hadir sebagai skutik premium Honda dengan pembaruan menyeluruh pada desain, rangka, mesin, dan fitur berteknologi tinggi. Model ini dirancang untuk memberikan kenyamanan berkendara kelas atas dengan performa yang bertenaga dan efisien."
      },
      {
        type: "paragraph",
        text: "Honda PCX 160 menggunakan mesin 160cc 4 katup enhanced Smart Power Plus (eSP+) berpendingin cairan yang menghasilkan performa responsif dengan tingkat efisiensi bahan bakar yang optimal untuk penggunaan harian."
      },
      {
        type: "heading",
        text: "Desain Premium dan Fitur Modern"
      },
      {
        type: "paragraph",
        text: "Tampilan Honda PCX 160 diperkuat dengan desain bodi besar berkarakter premium, sistem pencahayaan full LED, serta bagasi luas berkapasitas 30 liter yang mendukung aktivitas berkendara sehari-hari."
      },
      {
        type: "heading",
        text: "Performa Mesin dan Kenyamanan Berkendara"
      },
      {
        type: "paragraph",
        text: "Didukung rangka enhanced Smart Architecture Frame (eSAF), Honda PCX 160 menawarkan handling yang stabil, ringan, dan nyaman. Fitur keselamatan seperti ABS, Honda Selectable Torque Control (HSTC), serta teknologi Honda RoadSync tersedia pada tipe tertentu."
      }
    ]
  },


  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, 4 Katup, SOHC, eSP+, Pendingin Cairan"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "156,9 cc"],
      ["Daya Maksimum", "11,8 kW (16 PS) / 8.500 rpm"],
      ["Torsi Maksimum", "14,7 Nm / 6.500 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "enhanced Smart Architecture Frame (eSAF)"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Suspensi Belakang Ganda"],
      ["Rem Depan", "Cakram Hidrolik"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.936 x 742 x 1.123 mm"],
      ["Tinggi Jok", "764 mm"],
      ["Jarak Sumbu Roda", "1.313 mm"],
      ["Berat", "132–133 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "8,1 Liter"],
      ["Kapasitas Bagasi", "30 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },


  fullFeatures: {
    title: "Fitur Canggih Honda PCX 160",
    items: [
      {
        title: "5 Inch TFT Panel Meter",
        desc: "Panel meter TFT berwarna 5 inch dengan tampilan modern yang menyajikan informasi berkendara secara lengkap. *Tersedia pada tipe RoadSync."
      },
      {
        title: "Honda Smart Key System",
        desc: "Sistem keyless terintegrasi dengan alarm dan answer back system untuk meningkatkan keamanan dan kemudahan penggunaan."
      },
      {
        title: "Honda RoadSync",
        desc: "Teknologi konektivitas pintar yang menghubungkan sepeda motor dengan smartphone untuk navigasi dan notifikasi. *Tersedia pada tipe RoadSync."
      },
      {
        title: "Anti-Lock Braking System (ABS)",
        desc: "Sistem pengereman ABS untuk menjaga kestabilan dan mencegah roda terkunci saat pengereman mendadak. *Tersedia pada tipe ABS dan RoadSync."
      },
      {
        title: "Honda Selectable Torque Control (HSTC)",
        desc: "Fitur pengontrol traksi untuk menjaga kestabilan roda belakang pada kondisi jalan licin."
      },
      {
        title: "USB Type-C Charger",
        desc: "Fitur pengisian daya praktis untuk perangkat elektronik selama berkendara."
      },
      {
        title: "Full LED Lighting System",
        desc: "Sistem pencahayaan full LED pada lampu depan dan belakang untuk visibilitas optimal dan tampilan premium."
      },
      {
        title: "30 Liter Extra Large Luggage Box",
        desc: "Bagasi luas berkapasitas 30 liter yang dapat menyimpan helm dan barang bawaan lainnya."
      },
    ],
  },
};

export default pcxData;